import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairCancelRegistrationModalContainerLoadable =
  clientOnlyLazy({
    loader: () =>
      import(
        /* webpackChunkName: "StaffGradFairCancelRegistrationModalContainer" */
        './StaffGradFairCancelRegistrationModalContainer.dynamic'
      ),
    loading: LoadingModal,
  });
